if (!customElements.get('sommelier-picks-archive')) {
  customElements.define('sommelier-picks-archive', class SommelierPicksArchive extends HTMLElement {
    connectedCallback() {
      this.monthButtons = [...this.querySelectorAll('[data-sommelier-pick-month-button]')];
      this.pickCards = [...this.querySelectorAll('[data-sommelier-pick-month]')];
      this.staffSections = [...this.querySelectorAll('[data-sommelier-staff]')];

      this.monthButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectMonth(button.dataset.sommelierPickMonthButton, { updateUrl: true }));
      });

      const requestedMonth = new URLSearchParams(window.location.search).get('month');
      if (requestedMonth && this.monthButtons.some((button) => button.dataset.sommelierPickMonthButton === requestedMonth)) {
        this.selectMonth(requestedMonth);
      }
    }

    selectMonth(month, { updateUrl = false } = {}) {
      // NOTE: Keep filtering client-side so the latest month is already visible before JavaScript loads.
      // Reason: The archive must have a useful server-rendered landing state for customers and crawlers.
      this.monthButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.sommelierPickMonthButton === month));
      });

      this.pickCards.forEach((card) => {
        card.hidden = card.dataset.sommelierPickMonth !== month;
      });

      this.staffSections.forEach((section) => {
        section.hidden = ![...section.querySelectorAll('[data-sommelier-pick-month]')]
          .some((card) => !card.hidden);
      });

      if (updateUrl) {
        const archiveUrl = new URL(window.location.href);
        archiveUrl.searchParams.set('month', month);
        window.history.replaceState({}, '', archiveUrl);
      }
    }
  });
}
